'use es6';

import { List, Record } from 'immutable';
import Definition from './Definition';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  definitionCount: 0,
  definitions: List(),
  status: RequestStatus.UNINITIALIZED
};
export default class SmartContent extends Record(DEFAULTS) {
  static fromJS(data) {
    return new SmartContent({
      definitionCount: data.length,
      definitions: List(data).map(Definition.fromJS),
      status: RequestStatus.SUCCEEDED
    });
  }
}